<template>
  <div class="hardware-check-container">
    <div class="margin-top-16">
      <div class="sac__font-18 semi-bold">Hardware Check</div>
      <div class="card-container margin-top-16">
        <div class="detail-container">
          <div class="sac__font-16">Hub: {{ selectedUnit.uid }}</div>
          <div class="sac__font-16 n60">
            {{ selectedUnit.systemName }}
          </div>
          <div class="flex-row">
            <div class="sac__font-16 n60 mr-3">Connectivity: {{ hubConnectivity }}</div>
            <span v-if="hubStatus?.sensorRatio" class="online-status"> Online </span>
            <span v-else class="offline-status"> Offline </span>
          </div>
        </div>
        <div>
          <div class="sac__font-16 med">Sensors:</div>
          <div class="margin-top-16">
            <div class="small-card-container">
              <div
                v-for="(item, idx) in sensorListByUID"
                :key="idx"
                :class="['card', isOffline(item?.status) ? 'offline' : '']"
              >
                <div>
                  <div class="sac__font-16">
                    {{ SensorType[item.sensorType] }}
                  </div>
                  <div class="sac__font-14 n60 margin-top-8">
                    {{ item.location }}
                  </div>
                  <div class="grid-column ai-c jc-s gap-5 margin-top-8">
                    <div class="sac__font-14 n60">Accessory:</div>
                    <img
                      v-if="item.accessory"
                      src="@shared/assets/img/general/svg/check-black.svg"
                      class="img-size-20"
                    />
                    <img
                      v-else
                      src="@shared/assets/img/general/svg/x-black.svg"
                      class="img-size-20"
                    />
                  </div>
                </div>
                <div class="grid-column ai-c jc-b">
                  <SensorStatus :status="item?.status" />
                  <div class="sac__font-16 med">
                    {{ getSensorTemp(item.deviceId) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import SensorStatus from "@shared/components/customerDetail/performanceSummary/component/SensorStatus.vue";
import customerDetailMixin from "@shared/mixins/customerDetailMixin";
import unitPreferencesMixin from "@shared/mixins/unitPreferencesMixin";
import SensorType from "../../../lib/constant/SensorType";

export default {
  name: "HardwareCheck",
  components: { SensorStatus },
  mixins: [unitPreferencesMixin, customerDetailMixin],
  computed: {
    SensorType() {
      return SensorType;
    },
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
      allSensorList: (state) => state.customerDetail.sensors,
      rawPayloads: (state) => state.customerDetail.rawPayloads,
      hubList: (state) => state.customerDetail.hubs,
      hubConnectivity() {
        const hub = this.hubList.find((h) => h.uId === this.selectedUnit.uid);
        if (!hub) {
          return "NA";
        }
        return hub.connectMethod;
      },
      hubStatus() {
        const hub = this.hubList.find((h) => h.uId === this.selectedUnit.uid);
        return hub?.status;
      },
    }),
    serviceAddress() {
      const { serviceAddress } = this.selectedUnit;
      if (!serviceAddress) {
        return "--";
      }
      return serviceAddress.address1;
    },
    sensorListByUID() {
      const { uid } = this.selectedUnit;
      if (!uid) {
        return [];
      }
      return this.allSensorList.filter((sensor) => sensor.uId === uid);
    },
  },
  methods: {
    isOffline(status) {
      if (!status) {
        return true;
      }
      const { battery, sensorRatio } = status;

      if (!sensorRatio || battery === "Off" || !battery) {
        return true;
      }
      return false;
    },
    getSensorTemp(did) {
      const { TEMP_UNIT: tempFormat = "°F" } = this.customerPartnerSettings;

      const sensorReadingList = this.rawPayloads[this.selectedUnit.uid];
      if (Array.isArray(sensorReadingList)) {
        const matchingSensor = sensorReadingList.find((r) => r.did === did);
        if (matchingSensor && matchingSensor.temp) {
          return this.calculateTempUnit(matchingSensor.temp, tempFormat);
        }
      }
      return "--";
    },
  },
};
</script>

<style scoped lang="scss">
.hardware-check-container {
  .card-container {
    display: grid;
    gap: 1.5rem;
    padding: 2rem;
    background-color: $N5;
    .detail-container {
      padding: 1rem;
      display: grid;
      gap: 1rem;
      background-color: $WHITE;
      border-radius: 8px;
    }
    .small-card-container {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(min(15rem, 100%), 1fr));
      gap: 1.5rem;
      .card {
        border-radius: 6px;
        padding: 1rem;
        background-color: $WHITE;
        height: 12rem;
        display: grid;
        &.offline {
          border: 2px solid $TOMATO90;
        }
      }
    }
  }
}
.online-status {
  border: 1px solid $BASIL100;
  color: $N70;
  font-weight: 700;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 900px;
  display: flex;
  align-items: center;
}
.offline-status {
  border: 1px solid $TOMATO90;
  color: $N70;
  font-weight: 700;
  font-size: 10px;
  padding: 2px 10px;
  border-radius: 900px;
  display: flex;
  align-items: center;
}
</style>
